import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';
import appReducer from './appReducer';
import authReducer from './authReducer';
import ticketsReducer from './ticketsReducer';
import notificationReducer from './notificationReducer';
import ticketInfoReducer from './ticketInfoReducer';
import approvalFormInfoReducer from './approvalFormInfoReducer';
import adminReducer from './adminReducer';
import usersReducer from './usersReducer';
import richtextReducer from './richtextReducer';
import approvalFormsReducer from './approvalFormsReducer';

const reducersGroup = (history) => combineReducers({
  app: appReducer,
  auth: authReducer,
  admin: adminReducer,
  tickets: ticketsReducer,
  ticketInfo: ticketInfoReducer,
  notification: notificationReducer,
  users: usersReducer,
  richtext: richtextReducer,
  router: connectRouter(history),
  form: formReducer,
  approvalForm: approvalFormsReducer,
  approvalFormInfo: approvalFormInfoReducer,
});

export default reducersGroup;
